import React from "react";
import "./styles/services.css";

const services = [
  {
    title: "Air Suspension Installation & Maintenance",
    description: "Smooth ride with adjustable height control and expert maintenance.",
  },
  {
    title: "Custom Car Audio Installation",
    description: "High-performance sound systems tailored to your vehicle.",
  },
  {
    title: "Coilovers Installation & Maintenance",
    description: "Track-ready coilover setup and ongoing support.",
  },
  {
    title: "General Car Modifications & Diagnostics",
    description: "Customize and diagnose your car for better looks and performance.",
  },
  {
    title: "Standard Car Maintenance & Repairs",
    description: "Reliable servicing, repairs, and regular maintenance for all vehicles.",
  },
  {
    title: "Suspension Repairs & Upgrades",
    description: "Standard suspension fixes and performance-focused upgrades.",
  },
  
  {
    title: "Air Suspension Bluetooth Management System",
    description: "Our exclusive system for total control, performance, and convenience.",
  },
];

const Services = () => {
  return (
    <section id="services" className="service-section">
      <div className="service-container">
        <h2>Our Services</h2>
        <div className="service-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
